// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { EntidadInputProps } from '../../../interfaces'
import { LoteFragment } from '../interfaces/fragment'
import { LoteApiInputProps, LoteBaseProps } from '../../../interfaces/lote.ts'

const gqlQuery = gql`
  ${LoteFragment}
  mutation REGISTRO(
    $codigoLote: String!
    $entidad: EntidadParamsInput!
    $input: LoteInput!
  ) {
    loteRegistro(codigoLote: $codigoLote, entidad: $entidad, input: $input) {
      ...field
    }
  }
`

/**
 * API REST para el upsert de un lote
 * @param codigoLote
 * @param input
 * @param entidad
 */
export const apiLoteRegistro = async (
  codigoLote: string,
  input: LoteApiInputProps,
  entidad: EntidadInputProps | null,
): Promise<LoteBaseProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(gqlQuery, {
      codigoLote,
      input,
      entidad,
    })
    return data.loteRegistro
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
